import { render, staticRenderFns } from "./TextRecommendationCardTitleDetail.vue?vue&type=template&id=1305e662&scoped=true"
import script from "./TextRecommendationCardTitleDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationCardTitleDetail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationCardTitleDetail.vue?vue&type=style&index=0&id=1305e662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305e662",
  null
  
)

export default component.exports